import React, { Component } from 'react'
import IconBackground from '../../../../assets/svgs/icons/toolbar/menu/text/background.png'
import IconPicker from '../../icons/toolbar/menu/text/Picker'
import IconText from '../../icons/toolbar/menu/text/Text'

import ColourPicker from '../../modal/toolbar/text/ColourPicker'

export default class TextMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      showBackGroundColourModal: false,
      showTextColourModal: false,
    }
  }

  static getDerivedStateFromProps(nextProps, state) {
    return nextProps
  }

  render() {
    return (
      <>
        <div className="text-menu">
          <div className="row gx-5 align-items-center justify-content-center icons">
            <div style={this.props.containerStyle} className="col-auto">
              <a
                href="javascript:void(0)"
                onClick={() => {
                  this.setState((prevState) => ({
                    showBackGroundColourModal:
                      !prevState.showBackGroundColourModal,
                  }))
                }}
              >
                <img
                  width="18"
                  height="18"
                  className="asset"
                  src={IconBackground}
                />
              </a>
            </div>

            <div style={this.props.containerStyle} className="col-auto">
              <a
                href="javascript:void(0)"
                onClick={() => {
                  this.setState({ showTextColourModal: true })
                }}
              >
                <IconText />
              </a>
            </div>
          </div>
        </div>

        <ColourPicker
          title="Background Color"
          show={this.state.showBackGroundColourModal}
          onUpdated={(color) => {
            this.props.onTextBackgroundColorChanged(color)
          }}
          onHide={() => this.setState({ showBackGroundColourModal: false })}
        />

        <ColourPicker
          title="Text Color"
          show={this.state.showTextColourModal}
          onUpdated={(color) => {
            this.props.onTextColorChanged(color)
          }}
          onHide={() => this.setState({ showTextColourModal: false })}
        />
      </>
    )
  }
}
